import React from 'react';
import ViewAdminSchedules from '../ViewAdminSchedules';

const ScheduleByInstitutionPage = () => <ViewAdminSchedules scheduleType="institution" />;

export default ScheduleByInstitutionPage;
